
import React, { Component } from 'react';
import styles from '../Home/home.module.css';
import { connect } from "react-redux";
import { GetFacilityBackgroundImage } from '../../../action/invoiceAction';
import FM_bg_image from 'Assets/images/facilitymgmt_bg.jpeg';


class NoZonesMessage extends Component {

    constructor(props) {
        super(props);
        this.state = { redirect: false, imagePreviewUrl:this.props.homeImage_response.FacilityImage };
    }

    componentWillMount() {
        this.props.GetFacilityBackgroundImage();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            if (nextProps.homeImage_response != null && nextProps.homeImage_response.FacilityImage != null) {
                this.setState({
                    imagePreviewUrl: nextProps.homeImage_response.FacilityImage
                });
            }
        }   
    }

    render() {
        let backgroundImage = (this.state.imagePreviewUrl ===undefined ||this.state.imagePreviewUrl ===null )? FM_bg_image : this.state.imagePreviewUrl;

        return (
            <div style={{ backgroundImage: 'url('+backgroundImage+')' }} className={styles.homeContainer}>
                <div className={styles.messageContainer} >
                    <p className={styles.noZonesText}>Sorry, there are no zones associated to your account to allow you to make an After-Hours request.</p>
                    <p className={styles.noZonesText}>Contact your property manager or building administrator to request access.</p>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        homeImage_response: state.InvoiceRootReducer,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        GetFacilityBackgroundImage: () => dispatch(GetFacilityBackgroundImage()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NoZonesMessage);

